import React, { useEffect, useState } from "react";
import BonusMenu from "./BonusMenu";
import { BonusTable } from "./BonusTable";
import { Alert, AlertTitle, Box } from "@mui/material";
import { findAllEmployeeAction } from "../../../actions/employeeManagmentAction";
import { listBonusEndrolledAppEmployeeAction } from "../../../actions/aplicationActions/applicationsAction.js";
import { useDispatch, useSelector } from "react-redux";
import usePrivilegeCheck from "../../../constants/customHooks/UsePrivilegeCheck.js";
import DownloadPdf from "../../extraComponents/DownloadPdf.js";
import DownloadExcel from "../../extraComponents/DownloadExcel.js";

function BonusMain() {
  const dispatch = useDispatch();

  const [allEmployeeData, setAllEmployeeData] = useState([]);
  const [data, setData] = useState([]);
  const { privilege, hasPrivilege } = usePrivilegeCheck();
  const [paginationNumber, setPaginationNumber] = useState(1);
  const [limit, setLimit] = useState(10);

  let { bonusEmployeesSuccess } = useSelector((state) => {
    return state.listBonusEndrolledAppEmployee;
  });

  let columns = [
    {
      title: "SL NO",
      field: "SL NO"
    },
    {
      title: "ID",
      field: "ID"
    },
    {
      title: "NAME",
      field: "NAME"
    },
    {
      title: "ROLE",
      field: "ROLE"
    },
    {
      title: "ENROLLMENT COUNT",
      field: "ENROLLMENT COUNT"
    },
    // {
    //   title: "DATE ",
    //   field: "DATE ",
    // },

    {
      title: "Actions",
      field: "action",
      filtering: false
    }
  ];

  useEffect(() => {
    if (bonusEmployeesSuccess && bonusEmployeesSuccess !== undefined) {
      let results = bonusEmployeesSuccess?.payload?.map((item) => ({
        id: item?.user?.id,
        employeeId: item?.user?.employeeId ? item?.user?.employeeId : "-",
        name: item?.user?.firstName ? item?.user?.firstName : "-",
        role: item?.user?.role?.roleName ? item?.user?.role?.roleName : "-",
        enrollmentCount: item?.leads
          ? item.leads
          : item?.leadShortlists
          ? item.leadShortlists
          : 0
        // date: "20 / 02 / 2023",
      }));
      setAllEmployeeData(results);
      setData(results);
    }
  }, [bonusEmployeesSuccess]);

  useEffect(() => {
    dispatch(listBonusEndrolledAppEmployeeAction(limit, paginationNumber));
  }, [dispatch, limit, paginationNumber]);

  const handleSearch = (e) => {
    let filteredValues = allEmployeeData?.filter((row) =>
      row.name.toLowerCase().includes(e.target.value.toLowerCase())
    );
    setData(filteredValues);
  };

  const excelDownloadClick = (e) => {
    let columnName = columns.filter((value) => value.filtering !== false);

    DownloadExcel(columnName, data, "Bonus_Report");
  };

  const pdfDownloadClick = (e) => {
    let columnName = columns.filter((value) => value.filtering !== false);
    DownloadPdf(columnName, data, "Bonus_Report", "Bonus Report");
  };

  const pageNumberFetching = (pageNumber) => {
    try {
      setPaginationNumber(pageNumber);
    } catch (error) {
      console.error(error);
    }
  };

  const pageLimitFetching = (limit) => {
    try {
      setLimit(limit);
    } catch (error) {
      console.error(error);
    }
  };

  if (!hasPrivilege("bonus") && privilege !== null) {
    return (
      <Alert severity="error">
        <AlertTitle>warning</AlertTitle>
        You don't have permission to access — <strong>this page.!</strong>
      </Alert>
    );
  }

  return (
    <Box>
      <BonusMenu
        handleSearch={handleSearch}
        excelDownloadClick={excelDownloadClick}
        pdfDownloadClick={pdfDownloadClick}
      />
      <Box
        sx={{
          mt: "26px",
          overflow: "hidden"
        }}
      >
        <BonusTable
          columns={columns}
          data={data}
          subMenu="bonus"
          pageNumberFetching={pageNumberFetching}
          pageLimitFetching={pageLimitFetching}
          totalCount={bonusEmployeesSuccess?.totalCount}
        />
      </Box>
    </Box>
  );
}

export default BonusMain;
